import React, { useRef, useState, useEffect } from "react";
import { workCategories, servicesData } from "@/data/mock";
import { ArrowUpRight } from "lucide-react";

const FeaturedWork = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.05 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="my-work" ref={sectionRef} className="bg-[#F5F0E8] pt-12 pb-24 lg:pt-16 lg:pb-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Title */}
        <h2
          className={`font-bebas text-4xl sm:text-5xl lg:text-7xl text-[#1A1A1A] tracking-[0.1em] text-center mb-12 sm:mb-16 transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          MY WORK
        </h2>

        {/* Category Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-16">
          {workCategories.map((cat, index) => (
            <div
              key={cat.id}
              className={`group relative aspect-[3/4] overflow-hidden cursor-pointer transition-all duration-700 ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: visible ? `${index * 120 + 200}ms` : "0ms" }}
            >
              <img
                src={cat.image}
                alt={cat.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/40 group-hover:bg-black/55 transition-all duration-500" />
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <h3 className="font-bebas text-2xl md:text-3xl text-white tracking-[0.1em] mb-1">
                  {cat.title}
                </h3>
                <p className="font-inter text-xs text-white/50 tracking-[0.15em] uppercase">
                  {cat.subtitle}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Services Boxes */}
        <div
          className={`transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
          style={{ transitionDelay: visible ? "600ms" : "0ms" }}
        >
          <p className="font-inter text-xs tracking-[0.25em] uppercase text-[#8B7355] text-center mb-8">
            What I Offer
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
            {servicesData.map((service, index) => (
              <div
                key={service.id}
                className="flex items-center justify-center py-5 lg:py-6 border border-[#1A1A1A]/20 hover:border-[#1A1A1A] transition-colors duration-300 cursor-pointer"
              >
                <h3 className="font-bebas text-base lg:text-lg text-[#1A1A1A] tracking-[0.08em] text-center">
                  {service.title.toUpperCase()}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedWork;
